import AccommodationLandingHero from "@modules/accommodation/landing/hero";
import { LayoutMain } from "@unisearch/theme/layout";
import { useRouter } from "next/router";
import { useEffect } from "react";

const Accommodation = () => {
  const router = useRouter();

  useEffect(() => {
    if (typeof window !== "undefined") {
      (function(w, d, s, o, f, js, fjs) {
        w[o] =
          w[o] ||
          function() {
            (w[o].q = w[o].q || []).push(arguments);
          };
        (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
        js.id = o;
        js.src = f;
        js.async = 1;
        fjs.parentNode.insertBefore(js, fjs);
      })(
        window,
        document,
        "script",
        "_aw",
        "https://d341zbz41jo7w1.cloudfront.net/widget/list/3.0.0.js"
      );
      _aw("init", {
        element: document.getElementById("amber-widget"), // required
        location: "london", // required
        partnerId: "unisearch-b557fd7b", // required
        numListings: 6, // optional default is 6
        sortBy: "relevance", // optional, can be 'price' or 'relevance', default is 'relevance'
        sortOrder: "desc", // optional, can be 'desc' or 'asc', default is 'desc'
      });
    }
  }, []);

  return (
    <LayoutMain
      title={"Accommodation Through UniSeach"}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/accommodation`}
    >
      <AccommodationLandingHero />
      <section>
        <div className="container">
          <div className="accommodation_page">
            <div id="amber-widget"></div>
          </div>
        </div>
      </section>
    </LayoutMain>
  );
};

export default Accommodation;
